import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
// Дизайн-система кабинета — те же токены, кнопки и раскладка, что во всех веб-проектах МК.
import './styles/base.css';
import './styles/app.css';
// Только то, чего в кабинете нет: доска, карточка задачи, выбор роли, формы.
import './styles/tracker.css';

// retry: false — на 401 клиент уже уводит на вход, а на 403/404 повтор ничего не изменит.
const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);